import { useUserStore } from '@/entities/User';
import { Typography } from '@/shared/ui/Typography';
import { SkeletonWrapper } from '@/features/Skeleton';
import Banknotes from '@/shared/assets/lk/banknotes.svg?react';
import HouseSchema from '@/shared/assets/lk/houseSchema.svg?react';
import CollectiblesImg375 from '@/shared/assets/lk/collectibles375.png';
import CollectiblesImg1920 from '@/shared/assets/lk/collectibles1920.png';
import CollectiblesImg1200 from '@/shared/assets/lk/collectibles1200.png';
import cls from './Collectibles.module.scss';

export const Collectibles = () => {
    const {
        user: { squareMeters, portfolioValue },
        isUserLoading,
    } = useUserStore();

    return (
        <article className={cls.container}>
            <Typography className={cls.title} as="h6" variant="h6_bold">
                У вас накоплено
            </Typography>
            <div className={cls.data}>
                <SkeletonWrapper width="142px" height="60px" isLoading={isUserLoading}>
                    <div className={cls.dataItem}>
                        <HouseSchema className={cls.svg} />
                        <Typography className={cls.text} as="h4" variant="h4_bold">
                            {squareMeters} м²
                        </Typography>
                    </div>
                </SkeletonWrapper>
                <SkeletonWrapper width="284px" height="60px" isLoading={isUserLoading}>
                    <div className={cls.dataItem}>
                        <Banknotes className={cls.svg} />
                        <Typography className={cls.text} as="h4" variant="h4_bold">
                            {portfolioValue?.toLocaleString('ru-ru') || 0} ₽
                        </Typography>
                    </div>
                </SkeletonWrapper>
            </div>
            <picture className={cls.image}>
                <source media="(max-width:767px)" srcSet={CollectiblesImg375} />
                <source media="(max-width:1220px)" srcSet={CollectiblesImg1200} />
                <img alt="collectibles" src={CollectiblesImg1920} />
            </picture>
        </article>
    );
};
